module.exports = __webpack_public_path__ + "img/choujiang2.c28dba8a.png";